import {createContext} from "react";
import QRCode from "../../../api/qr-code/QRCode";

type EditQRCodeContextType = {
    /**
     * QRCode we're editing.
     * @author Kacper Faber
     * @since 0.2.0
     */
    qrCode: QRCode | undefined;
}

/**
 * Default context values.
 * @author Kacper Faber
 * @since 0.2.0
 */
const defaults: EditQRCodeContextType = {
    qrCode: undefined
};

/**
 * Holds context for editing QR code.
 * @author Kacper Faber
 * @since 0.2.0
 */
const context = createContext(defaults);

export default context;